import React from 'react';
import { Col, Row } from 'react-bootstrap';

import Card from 'v3/components/Card';
import { Text } from 'v3/components';

import { getStatusColor } from '../shared/status';

const BORDER_GRAY = '#dee2e6';

export default function StatusCounters({ counts = [], loading = false, error = false }) {
  return (
    <Row style={{ opacity: loading ? 0.6 : 1 }} data-testid="status-counters">
      {counts.map((item) => {
        const color = getStatusColor(item.slug);
        return (
          // `xl` sem número = colunas de largura igual: os 7 status cabem numa linha só na tela
          // grande, e abaixo disso a grade continua quebrando (3, 2 e 1 por linha).
          <Col key={item.slug} xs={12} sm={6} lg={4} xl className="mb-3">
            <Card
              bodyCardPadding="1rem 1.25rem"
              style={{
                height: '100%',
                border: `1px solid ${BORDER_GRAY}`,
                borderTop: `4px solid ${color}`,
                borderRadius: 8,
              }}
              data-testid={`status-counter-${item.slug}`}
            >
              <Text
                type="label"
                color={color}
                weight="600"
                style={{ display: 'block', minHeight: '2.5em' }}
                data-testid="counter-status-name"
              >
                {item.name}
              </Text>
              <Text
                type="header"
                color="dark"
                weight="600"
                fontSize="1.75rem"
                style={{ display: 'block' }}
                data-testid="status-counter-total"
              >
                {error ? '-' : item.total}
              </Text>
            </Card>
          </Col>
        );
      })}
    </Row>
  );
}
